import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal';
export default function confirm(_a) {
  var getContainer = _a.getContainer,
      visible = _a.visible,
      restProps = __rest(_a, ["getContainer", "visible"]);

  var div = document.createElement('div');
  document.body.appendChild(div);

  function render(props) {
    setTimeout(function () {
      ReactDOM.render( /*#__PURE__*/React.createElement(Modal, _extends({}, props)), div);
    });
  }

  render(restProps);
}
export function withWarning(props) {
  return _extends(_extends({
    showline: false
  }, props), {
    type: 'warning'
  });
}
export function withError(props) {
  return _extends(_extends({
    showline: false
  }, props), {
    type: 'error'
  });
}
export function withConfirm(props) {
  return _extends(_extends({
    showline: false
  }, props), {
    type: 'confirm'
  });
}